import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew'
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader'
import api from 'http'
import EligibilityErrorList from 'MainTabs/Eligibility/Components/EligibilityErrorList'
import EligibilityLogDetail from 'MainTabs/Eligibility/Components/EligibilityLogDetail/EligibilityLogDetail'
import EligibilityLogGrid from 'MainTabs/Eligibility/Components/EligibilityLogGrid'
import RunEligibilityForm from 'MainTabs/Eligibility/Components/RunEligibilityForm'
import CostShare from 'MainTabs/Eligibility/Components/EligibilityLogDetail/CostShare'
import PatientPaymentsOverview from 'MainTabs/Patients/AllPatients/PatientPayments/PaymentSettings/PatientPaymentsOverview'
import FullScreenEligibilityPopup from 'Popups/FullScreenEligibilityPopup/FullScreenEligibilityPopup'
import SuperAccordion from 'Components/SuperAccordion/SuperAccordion'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import ParamListGen from 'Services/ParamListGen'
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage'
import { GetInsurancePlan } from 'Utils/Utils'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import { TODAY_DATE } from 'Common/Constants'
import AddNewPatientPaymentPopup from 'Popups/AddNewPatientPaymentPopup/AddNewPatientPaymentPopup'
import Show from 'Components/Show/Show'
const eligibilityDataDefault = {
    "id": 0,
    "clearingHouseEligibilityId": 0,
    "patientId": 0,
    "patientPlanId": 0,
    "providerId": 0,
    "payerId": "",
    "serviceType": "",
    "cptCode": "",
    "subscriberId": "",
    "subscriberGender": "",
    "subscriberDOB": "",
    "subscriberLastName": "",
    "subscriberFirstName": "",
    "subscriberCity": "",
    "subscriberState": "",
    "subscriberZip": "",
    "subscriberAddress1": "",
    "subscriberGroupName": "",
    "subscriberGroupNumber": "",
    "relationship": "",
    "eligibilityResultTime": "",
    "eligibilityResultDate": "",
    "eligibilityDate": "",
    "eligibilityStatus": "",
    "medicareStatus": "",
    "hmo": null,
    "ppo": null,
    "patientEligibilityBenefits": [],
    "patientEligibilityErrors": [],
    "inActive": false,
    "inActiveReason": null,
    "inActiveBy": null,
    "inActiveDate": null,
    "practiceId": 0,
    "addedBy": "",
    "addedDate": "",
    "updatedBy": "",
    "updatedDate": "",
}
const EligibilitySection = ({ patientId, singlePlan , patientName, initialEligibilityResult = null }) => {
    const [sectionsOpen, setSectionsOpen] = useState({
        eligibilitySearch: true,
        costShare: true,
        patientPayment: true,
        eligibilityDetails: true,
    })
    const [runEligibilityModel, setRunEligibilityModel] = useState({
        providerId: "",
        type: "serviceType",
        serviceTypeCode: "",
        accountKey: "",
        subscriberLastName: "",
        subscriberFirstName: "",
        payerId: "",
        patientRelation: "",
        dateOfService: TODAY_DATE,
        subscriberId: "",
        cptCode: "",
        patientDob: "",
        patientId: "",
        patientPlanId: "",
        createdBy: "",
        payerName: "",
        patientname: "",
        insurancePayerTypeId: null,
    })
    const [costShareData, setCostShareData] = useState({
        copay: "",
        deductible: "",
        coInsurance: "",
        outOfPocketMax: "",
        patientCredit: 0,
        lastPaymentDate: "",
        paidAmount: 0,
        patientBalance: 0,
    })
    const [addPaymentPopup, setAddPaymentPopup] = useState(false)
    const [costShareLoading, setCostShareLoading] = useState(false)
    const onToggleSection = (section) => {
        setSectionsOpen((prev) => ({ ...prev, [section]: !prev[section] }))
    }
    const [loader, setLoader] = useState(false)
    const [showLogs, setShowLogs] = useState(false)
    const [eligibilityData, setEligibilityData] = useState(() =>
      initialEligibilityResult && typeof initialEligibilityResult === "object"
        ? { ...eligibilityDataDefault, ...initialEligibilityResult }
        : eligibilityDataDefault
    )
    const [allInsPlans, setAllInsPlans] = useState([])
    const [singleRows, setSingleRows] = useState([])
    const [selectedPayer, setSelectedPayer] = useState("")
    const [pagination, setPagination] = useState({
        "perPage": 20,
        "pageNo": 1,
        "totalCount": 0,
    })
    const [fullEligibilityPopup, setFullEligibilityPopup] = useState(false)
    const logDetailRef = useRef(null)
    const logErrorlRef = useRef(null)
    const runEligibilityRef = useRef(null)

    const openFullEligibilityPopup = () => {
        setFullEligibilityPopup(true)
    }
    const closeFullEligibilityPopup = () => {
        setFullEligibilityPopup(false)
    }

    const handlePageChange = (pageno) => {
        setPagination((prev) => ({ ...prev, pageNo: pageno }))
    }
    const handlePerRowsChange = (rowsPerPage, pageno) => {
        setPagination((prev) => ({ ...prev, pageNo: pageno, perPage: rowsPerPage }))
    }
    const handleLogsShow = () => {
        setShowLogs((prev) => !prev)
        setEligibilityData(eligibilityDataDefault)
    }


    const handleLogsShowRow = async (id) => {
        if (id) {
            try {
                setLoader(true)
                const response = await api.get(`${process.env.REACT_APP_TC_PMS}/api/PatientEligibility/FindPatientEligibility/${id}`);
                setEligibilityData(response.data.dataModel)
                const payer = allInsPlans.find((ins) => ins.payerId === response.data.dataModel.payerId)
                setSelectedPayer(payer)
                setShowLogs(false)
            } catch (error) {
                ErrorHandlingMessage(error)
            }
            finally {
                setLoader(false)
            }
        }
    }

    const getEligibilityModel = async (response, model) => {
        try {
            setLoader(true)
            setEligibilityData(response.data.dataModel)
            setShowLogs(false)
            const eligibilityModel = {
                patientid: model.patientId,
                // patientplanid: model.patientPlanId,
                // payerid: model.payerId,
                // eligibilitystatus: "",
                // fromdate: "",
                // todate: "",
                // patientName: model.patientname,
                // payerName: model.payerName,
            }
            const payload = {
                param_list: ParamListGen(eligibilityModel),
                practiceId: 0,
                perPage: 10,
                pageNo: 1,
                totalPages: 0,
                totalCount: 0,
                isExportCall: false
            }
            const resp = await api.post(`${process.env.REACT_APP_TC_PMS}/api/PatientEligibility/FindPatientEligibility`, payload);
            setSingleRows(resp.data.dataModel.data)
            setPagination((prev) => ({ ...prev, totalCount: resp.data.dataModel.totalCount }))

        } catch (error) {
            ErrorHandlingMessage(error)
        }
        finally {
            setLoader(false)
        }
    }

    const printEligibilityData = (printFor) => {
        if (printFor === "logDetail") {
            logDetailRef.current.handlePrintPKG(null, () => logDetailRef.current.printContent())
        }
        else {
            logErrorlRef.current.handlePrintPKG(null, () => logErrorlRef.current.printContent())
        }
    }

    const fetchCostShareData = useCallback(async () => {
        try {
            if (runEligibilityModel.payerId && patientId) {
                setCostShareLoading(true)
                const response = await api.get(
                    `${process.env.REACT_APP_TC_PMS}/api/Patient/FindPatientInsuranceCostShare?PatientId=${patientId}`
                )
                const data = response.data?.dataModel
                if (data && Array.isArray(data)) {
                    const model = allInsPlans.find((item) => item.payerId === runEligibilityModel.payerId)
                    const matchedData = model ? data.find((item) => item.coverage === model.coverage) : null
                    setCostShareData(matchedData || data[0] || { copay: "", deductible: "", coInsurance: "", outOfPocketMax: "", patientCredit: 0, lastPaymentDate: "", paidAmount: 0, patientBalance: 0 })
                } else {
                    setCostShareData(data || { copay: "", deductible: "", coInsurance: "", outOfPocketMax: "", patientCredit: 0, lastPaymentDate: "", paidAmount: 0, patientBalance: 0 })
                }
            }
        } catch (error) {
            ErrorHandlingMessage(error)
        } finally {
            setCostShareLoading(false)
        }
    }, [patientId, allInsPlans, runEligibilityModel.payerId])

    useEffect(() => {
        if (patientId && runEligibilityModel.payerId) {
            fetchCostShareData()
        }
    }, [patientId, runEligibilityModel.payerId, fetchCostShareData])

    const effectivePatientId = patientId || runEligibilityModel.patientId

    useEffect(() => {

        (async () => {
            try {
                setLoader(true)
                const allPlansResp = await api.get(`${process.env.REACT_APP_TC_PMS}/api/DropDown/FindPatientPlanByPatientId?PatientId=${patientId}`)
                const insInfo = GetInsurancePlan(allPlansResp.data.dataModel)
                const primaryIns = allPlansResp.data.dataModel.find((ins) => ins.payerId === insInfo.payerId)
                const eligibilityModel = {
                    patientid: primaryIns.patientId,
                    // patientplanid: primaryIns.id,
                    // payerid: primaryIns.payerId,
                    // eligibilitystatus: "",
                    // fromdate: "",
                    // todate: "",
                    // patientName: primaryIns.patientName,
                    // payerName: primaryIns.insurancePayerName,
                }
                const payload = {
                    param_list: ParamListGen(eligibilityModel),
                    practiceId: 0,
                    perPage: pagination.perPage,
                    pageNo: pagination.pageNo,
                    totalPages: 0,
                    totalCount: 0,
                    isExportCall: false
                }
                const respssss = await api.post(`${process.env.REACT_APP_TC_PMS}/api/PatientEligibility/FindPatientEligibility`, payload);
                setSingleRows(respssss.data.dataModel.data)
                setPagination((prev) => ({ ...prev, totalCount: respssss.data.dataModel.totalCount }))
                setAllInsPlans(allPlansResp.data.dataModel)
            } catch (error) {
                ErrorHandlingMessage(error)
            } finally {
                setLoader(false)
            }
        })();
    }, [patientId, singlePlan, pagination.perPage, pagination.pageNo])
    return (
        <>
            {(loader || costShareLoading) && <FullPageLoader allowFullScreen />}
            {fullEligibilityPopup && <FullScreenEligibilityPopup onClose={closeFullEligibilityPopup} eligibilityData={eligibilityData} />}
            <Show when={addPaymentPopup}>
                <AddNewPatientPaymentPopup
                    currentTab="patient payments"
                    patientId={effectivePatientId}
                    onClose={() => setAddPaymentPopup(false)}
                    onPaymentConfirmed={fetchCostShareData}
                    handleSubmit={fetchCostShareData}
                />
            </Show>

            {/* Eligibility Search - collapsible */}
            <div className="border rounded-lg border-slate-200 overflow-hidden">
                <div
                    className="flex items-center justify-between cursor-pointer py-3 px-4 bg-slate-50 border-b border-slate-200"
                    onClick={() => onToggleSection('eligibilitySearch')}
                >
                    <h2 className="text-lg font-semibold text-gray-900">Eligibility Search</h2>
                    <div className="flex items-center gap-2">
                        <div onClick={(e) => e.stopPropagation()}>
                            <CustomButtonNew onClick={() => runEligibilityRef.current?.runEligibility()} label="Run Eligibility" />
                        </div>
                        {sectionsOpen.eligibilitySearch ? <FiChevronUp className="text-gray-500 shrink-0 cursor-pointer" /> : <FiChevronDown className="text-gray-500 shrink-0 cursor-pointer" />}
                    </div>
                </div>
                <SuperAccordion show={sectionsOpen.eligibilitySearch}>
                    <div className="p-4">
                        <RunEligibilityForm
                            ref={runEligibilityRef}
                            hideRunButton
                            hideCostShareAndPayment
                            runEligibilityModel={runEligibilityModel}
                            setRunEligibilityModel={setRunEligibilityModel}
                            costShareData={costShareData}
                            setCostShareData={setCostShareData}
                            allPayers={allInsPlans}
                            fetchCostShareData={fetchCostShareData}
                            allPlans={allInsPlans}
                            providerId={eligibilityData?.providerId}
                            dateOfService={eligibilityData?.eligibilityDate}
                            cptCode={eligibilityData?.cptCode}
                            serviceType={eligibilityData?.serviceType || ""}
                            patientId={patientId}
                            singlePlan={selectedPayer || singlePlan}
                            getEligibilityModel={getEligibilityModel}
                            patientName={patientName}
                        />
                    </div>
                </SuperAccordion>
            </div>

            {/* Cost Share - collapsible (separate section) */}
            <div className="border rounded-lg border-slate-200 overflow-hidden">
                <div
                    className="flex items-center justify-between cursor-pointer py-3 px-4 bg-slate-50 border-b border-slate-200"
                    onClick={() => onToggleSection('costShare')}
                >
                    <h2 className="text-lg font-semibold text-gray-900">Cost Share</h2>
                    {sectionsOpen.costShare ? <FiChevronUp className="text-gray-500 shrink-0 cursor-pointer" /> : <FiChevronDown className="text-gray-500 shrink-0 cursor-pointer" />}
                </div>
                <SuperAccordion show={sectionsOpen.costShare}>
                    <div className="p-4">
                        <CostShare
                            className="my-0"
                            coverage={runEligibilityModel?.coverage}
                            costShareData={costShareData}
                            allPayers={allInsPlans}
                            runEligibilityModel={runEligibilityModel}
                            loading={false}
                        />
                    </div>
                </SuperAccordion>
            </div>

            {/* Patient Payment - collapsible (separate section) */}
            <div className="border rounded-lg border-slate-200 overflow-hidden">
                <div
                    className="flex items-center justify-between cursor-pointer py-3 px-4 bg-slate-50 border-b border-slate-200"
                    onClick={() => onToggleSection('patientPayment')}
                >
                    <h2 className="text-lg font-semibold text-gray-900">Patient Payment</h2>
                    <div className="flex items-center gap-2">
                        <div onClick={(e) => e.stopPropagation()}>
                            <CustomButtonNew
                                onClick={() => setAddPaymentPopup(true)}
                                label="Add Payment"
                                disabled={!effectivePatientId}
                            />
                        </div>
                        {sectionsOpen.patientPayment ? <FiChevronUp className="text-gray-500 shrink-0 cursor-pointer" /> : <FiChevronDown className="text-gray-500 shrink-0 cursor-pointer" />}
                    </div>
                </div>
                <SuperAccordion show={sectionsOpen.patientPayment}>
                    <div className="p-4">
                        <PatientPaymentsOverview patientAccountInfo={{
                            patientBalance: costShareData?.patientBalance || 0,
                            patientCredit: costShareData?.patientCredit || 0,
                            lastPaymentDate: costShareData?.lastPaymentDate || "",
                            extraClass: "px-4 py-2",
                            paidAmount: costShareData?.paidAmount || 0,
                        }} />
                    </div>
                </SuperAccordion>
            </div>

            {/* Eligibility Details / Log - collapsible */}
            <div className="border rounded-lg border-slate-200 overflow-hidden">
                <div
                    className="flex items-center justify-between cursor-pointer py-3 px-4 bg-slate-50 border-b border-slate-200"
                    onClick={() => onToggleSection('eligibilityDetails')}
                >
                    <h2 className="text-lg font-semibold text-gray-900">Eligibility {showLogs ? "Log" : "Details"}</h2>
                    <div className="flex items-center gap-2">
                        <div className="flex items-center gap-3" onClick={(e) => e.stopPropagation()}>
                            {eligibilityData.eligibilityStatus === "Completed" ? <img className='h-5 cursor-pointer' title="Go Fullscreen" onClick={openFullEligibilityPopup} src="/img/openScreen.svg" alt="openscreen" /> : null}
                            {eligibilityData.id ?
                                eligibilityData.eligibilityStatus === "Completed" ? <CustomButtonNew onClick={() => printEligibilityData("logDetail")} label="Print" /> : <CustomButtonNew onClick={() => printEligibilityData("errorDetail")} label="Print" />
                                : null}
                            {!showLogs && eligibilityData.id ? <CustomButtonNew onClick={handleLogsShow} prefixIcon={<img width={16} src='/img/eyeOpen.svg' alt='show' />} label="Show Eligibility Log" /> : null}
                        </div>
                        {sectionsOpen.eligibilityDetails ? <FiChevronUp className="text-gray-500 shrink-0 cursor-pointer" /> : <FiChevronDown className="text-gray-500 shrink-0 cursor-pointer" />}
                    </div>
                </div>
                <SuperAccordion show={sectionsOpen.eligibilityDetails}>
                    {sectionsOpen.eligibilityDetails && (
                        <div className="p-4">
                            {eligibilityData.id ? (
                                eligibilityData.eligibilityStatus === "Completed" ? <EligibilityLogDetail eligibilityData={eligibilityData} ref={logDetailRef} /> : <EligibilityErrorList eligibilityData={eligibilityData} ref={logErrorlRef} />
                            ) : (
                                <EligibilityLogGrid
                                    rows={singleRows}
                                    handleLogsShowRow={handleLogsShowRow}
                                    handlePageChange={handlePageChange}
                                    handlePerRowsChange={handlePerRowsChange}
                                    pagination={pagination}
                                />
                            )}
                        </div>
                    )}
                </SuperAccordion>
            </div>
        </>
    )
}

export default EligibilitySection